import {Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {filter} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

import {MaterialModule} from '../../../../material.module';
import {ToastService} from '../../../../services/layout/toast.service';
import {ClientService} from '../../../../services/auth/client.service';
import {FunctionType, IFunctionOptions, IWorkflowFunctionBinding} from '../../../../models/function-options.model';
import {ClientStateService} from '../../../../services/auth/client-state.service';
import {ProductType} from '../../../../models/client-options.model';
import {FunctionWorkflowBindingSelectorComponent} from '../function-workflow-binding-selector/function-workflow-binding-selector.component';

@Component({
  selector: 'app-function-general-settings',
  templateUrl: './function-general-settings.component.html',
  styleUrls: ['./function-general-settings.component.scss'],
    imports: [MaterialModule, ReactiveFormsModule, FunctionWorkflowBindingSelectorComponent]
})
export class FunctionGeneralSettingsComponent implements OnInit {
    private snackBar = inject(ToastService);
    private clientService = inject(ClientService);
    private clientStateService = inject(ClientStateService);
    private destroyRef = inject(DestroyRef);

  @Input() settingsForm!: FormGroup;
  @Input() workflowBinding: IWorkflowFunctionBinding | null = null;
  @Input() formSubmissionTargets: IFunctionOptions[] = [];
  @Output() workflowBindingChange = new EventEmitter<IWorkflowFunctionBinding | null>();
  @Output() formSubmissionTargetChange = new EventEmitter<string>();

  functionTypes: FunctionType[] = [];

  ngOnInit(): void {
    if (!this.settingsForm) {
      throw new Error('settingsForm Input is required for FunctionGeneralSettingsComponent');
    }

    this.syncFunctionTypes();
    this.settingsForm.get('type')?.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.syncFunctionTypes());

    this.clientStateService.clientLoading$
      .pipe(
        filter(isLoading => !isLoading),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => this.syncFunctionTypes());
  }

  private syncFunctionTypes(): void {
    const functionTypes: FunctionType[] = ['Logic App', 'Email', 'UI', 'Products', 'ProductCard'];

    if (this.clientService.hasProduct(ProductType.ShineConnect)) {
      functionTypes.push('Workflow');
    }

    const selectedType = this.settingsForm.get('type')?.value;
    if (typeof selectedType === 'string' && !functionTypes.includes(selectedType as FunctionType)) {
      functionTypes.push(selectedType as FunctionType);
    }

    this.functionTypes = functionTypes;
  }

  updateWorkflowBinding(binding: IWorkflowFunctionBinding | null): void {
    this.workflowBinding = binding;
    this.workflowBindingChange.emit(binding);
  }

  updateFormSubmissionTarget(functionId: string): void {
    this.formSubmissionTargetChange.emit(functionId);
  }
}
